import type { ObraCardProps } from "./types-obra-card";
import { useObraCard } from "./use-obra-card";
import { ObraCardView } from "./view-obra-card";

/**
 * Corpo do card de obra (Figma cards-kanban 713:28467, mobile 10720:59140): código e embarcação, `IconeBarco`, período e
 * duração, `TipoObraTags`, "Realizado R$ x / R$ y" com a barra e as métricas EM, CO, ES e NC com tooltip. A moldura é a
 * do `Kanban.Card` do DS.
 */
export function ObraCard(props: ObraCardProps) {
  const vm = useObraCard(props);

  return <ObraCardView {...vm} />;
}

export { OBRA_CARD_METRICAS, OBRA_CARD_SEM_VALOR } from "./obra-card.constants";
export type * from "./types-obra-card";
